// Show field 'Wunschtermin' if 'Wunschtermin' is selecteded from the 'Kündigungsdatum' selectbox
$(function () {
    var $wunschtermin = $('.kuendigungsdatum-wunschtermin');
    $wunschtermin.hide();
    $('.container-selectbox--kuendigungsdatum').find('select').change(function () {
        var currentValue = this.value;
        currentValue === 'Wunschtermin' ?  $wunschtermin.show() : $wunschtermin.hide();
    });
});
